import React from 'react';
import Text from '../../../components/text/Text';
import { Card, SectionTitle } from '../../../design/components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const SetupSection = ({
	title,
	description,
	children,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<Card>
			{
				title && (
					<SectionTitle title={title} style={styles.title} />
				)
			}
			{
				description && (
					<Text style={styles.description}>{description}</Text>
				)
			}
			{children}
		</Card>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	title: {
		marginBottom: space.sm,
	},
	description: {
		...type.secondary,
		color: colors.textSecondary,
		marginBottom: space.md,
	},
});

export default SetupSection;
